import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const canUploadColumns = (intl = null, es = false) => {
  let itRet = [
    {
      className: "companyName",
      dataIndex: "companyName",
      key: "companyName"
    },
    {
      className: "dataColumn",
      title: intl?.formatMessage({id: "permissions.Via web"}) || "Via Web",
      dataIndex: "web",
      key: "web",
      render: (web) =>
        web === true ? (
          <FontAwesomeIcon
            icon={["fas", "check-circle"]}
            style={{
              color: "#09822a",
              fontSize: "14px"
            }}
          />
        ) : (
          <FontAwesomeIcon
            icon={["fas", "minus-circle"]}
            style={{
              color: "#d82829",
              fontSize: "14px"
            }}
          />
        )
    },
    {
      className: "dataColumn",
      title: intl?.formatMessage({id: "permissions.Via app"}) || "Via App",
      dataIndex: "app",
      key: "app",
      render: (app) =>
        app === true ? (
          <FontAwesomeIcon
            icon={["fas", "check-circle"]}
            style={{
              color: "#09822a",
              fontSize: "14px"
            }}
          />
        ) : (
          <FontAwesomeIcon
            icon={["fas", "minus-circle"]}
            style={{
              color: "#d82829",
              fontSize: "14px"
            }}
          />
        )
    }
  ];
  if (!es) {
    itRet.push({
      className: "dataColumn",
      title: intl?.formatMessage({id: "permissions.Via mail"}) || "Via Mail",
      dataIndex: "email",
      key: "email",
      render: (email) =>
        email === true ? (
          <FontAwesomeIcon
            icon={["fas", "check-circle"]}
            style={{
              color: "#09822a",
              fontSize: "14px"
            }}
          />
        ) : (
          <FontAwesomeIcon
            icon={["fas", "minus-circle"]}
            style={{
              color: "#d82829",
              fontSize: "14px"
            }}
          />
        )
    });
    itRet.push({
      className: "dataColumn",
      title: intl?.formatMessage({id: "permissions.Auto invio XML"}) || "Auto invio XML",
      dataIndex: "xml",
      key: "xml",
      render: (xml) =>
        xml === true ? (
          <FontAwesomeIcon
            icon={["fas", "check-circle"]}
            style={{
              color: "#09822a",
              fontSize: "14px"
            }}
          />
        ) : (
          <FontAwesomeIcon
            icon={["fas", "minus-circle"]}
            style={{
              color: "#d82829",
              fontSize: "14px"
            }}
          />
        )
    });
  }
  return itRet;
};
